import { Type } from "class-transformer";
import { BaseModel } from "../base.model";

export class FormTemplateEmail extends BaseModel {
  id: number;
  @Type(() => Boolean)
  sendReminderEmails: boolean;
}
